import InboxWeb from './InboxWeb';

export default InboxWeb;
